import Icon from 'app/components/Icon';
import { ModalsContext } from 'app/components/Layouts/Modals';
import React, { useContext, useEffect } from 'react'

interface Props {
    children?
 }

function ModalLayout(props: Props) {
    const { children } = props

    const {close} = useContext(ModalsContext)

    useEffect(() => {
        document?.body.classList.add("overflow-y-hidden");
        return () => {
            document?.body.classList.remove("overflow-y-hidden");
        }
    }, [])

    return (
        <div className='fixed top-0 left-0 z-99999 bg-black/30 backdrop-blur-2xl flex items-center justify-center w-full min-h-screen mob:h-screen mob:overflow-auto mob:px-12px mob:py-100px mob:items-start'>
            {/* <div onClick={(e) => { e.preventDefault(); close() }} className="fixed top-1/2 cursor-pointer right-50px w-50px h-50px bg-red rounded-full flex items-center justify-center">
                <Icon className={"text-white w-16px"} name="cross" />
            </div> */}
            {children}
        </div>
    )
}

export default ModalLayout
